<div class="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-5 h-full flex flex-col">

  <!-- Header del widget: título + ícono -->
  <div class="flex items-start justify-between mb-4">
    <div>
      <p class="text-sm text-gray-600 dark:text-gray-400 font-medium m-0">{{ title }}</p>
      <p *ngIf="subtitle" class="text-xs text-gray-400 dark:text-gray-500 mt-1 m-0">{{ subtitle }}</p>
    </div>
    <div class="w-8 h-8 rounded-lg flex items-center justify-center" [class]="iconBgClass">
      <ng-content select="[icon]"></ng-content>
    </div>
  </div>

  <!-- Contenido según estado -->
  <div class="flex-1">

    <!-- LOADING: skeleton -->
    <div *ngIf="state === 'loading'" class="animate-pulse space-y-3">
      <div class="h-8 bg-gray-200 dark:bg-gray-700 rounded w-2/3"></div>
      <div class="h-4 bg-gray-200 dark:bg-gray-700 rounded w-1/2"></div>
      <div class="space-y-2 mt-4">
        <div class="h-3 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div class="h-3 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
      </div>
    </div>

    <!-- ERROR -->
    <div *ngIf="state === 'error'" class="flex flex-col items-center justify-center text-center py-6">
      <div class="w-10 h-10 rounded-full bg-red-50 dark:bg-red-900/20 flex items-center justify-center mb-2">
        <svg class="w-5 h-5 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <p class="text-sm text-gray-600 dark:text-gray-400 m-0">{{ errorMessage }}</p>
      <button class="mt-3 text-xs text-blue-600 dark:text-blue-400 hover:underline" (click)="retry.emit()">
        Reintentar
      </button>
    </div>

    <!-- EMPTY -->
    <div *ngIf="state === 'empty'" class="flex flex-col items-center justify-center text-center py-6">
      <p class="text-sm text-gray-500 dark:text-gray-400 m-0">{{ emptyMessage }}</p>
    </div>

    <!-- READY: contenido del widget -->
    <div *ngIf="state === 'ready'">
      <ng-content></ng-content>
    </div>

  </div>

  <!-- Drill-down opcional al pie -->
  <div *ngIf="drillDownLabel && state === 'ready'" class="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700">
    <button class="text-xs text-blue-600 dark:text-blue-400 hover:underline" (click)="drillDown.emit()">
      {{ drillDownLabel }}
    </button>
  </div>

</div>